// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import FlowSettingMenu from 'presentations/views/components/molecules/FloatSettingMenu';
import { spacing, fontSize } from 'presentations/views/styles';
import { TaxRateListItem as TaxRateListItemSchema } from 'presentations/api/schema/tax_rate';
import TaxRateListItem, {
  LoadingComponent,
} from 'presentations/views/components/molecules/TaxRateListItem';
import { Role } from 'domains/models/team_user/role';
import { ViewerItem } from 'presentations/api/schema/user';

export interface Props {
  taxRates: TaxRateListItemSchema[];
  onSelectMenu?: any;
  viewer: ViewerItem;
  isLoading?: boolean;
}

export enum TaxRateOptionIndex {
  edit = 0,
  delete = 1,
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const [
    anchorTaxRate,
    setAnchorTaxRate,
  ] = useState<null | TaxRateListItemSchema>(null);
  const onCloseMenu = () => {
    setAnchor(null);
    setAnchorTaxRate(null);
  };
  const onClickMenu = (e: any, taxRate: TaxRateListItemSchema) => {
    e.preventDefault();
    setAnchor(e.currentTarget);
    setAnchorTaxRate(taxRate);
  };
  const onSelectMenu = async (selectedIndex: number) => {
    if (!anchorTaxRate) return;
    setAnchor(null);
    props.onSelectMenu(anchorTaxRate, selectedIndex);
  };

  const renderMenu = (taxRate: TaxRateListItemSchema, role: Role) => {
    if (!anchorTaxRate) return null;
    if (anchorTaxRate.id !== taxRate.id) return null;
    if (role > Role.Admin) return null;

    const options = [];
    options.push({
      icon: 'edit',
      label: t('Edit'),
    });
    options.push({
      icon: 'delete',
      label: t('Delete'),
    });
    return (
      <FlowSettingMenu
        onCloseMenu={onCloseMenu}
        onSelectMenu={onSelectMenu}
        anchor={anchor}
        options={options}
      />
    );
  };

  return (
    <Container>
      {props.isLoading && (
        <>
          <TaxRateListItemWrap>
            <LoadingComponent />
          </TaxRateListItemWrap>
          <TaxRateListItemWrap>
            <LoadingComponent />
          </TaxRateListItemWrap>
          <TaxRateListItemWrap>
            <LoadingComponent />
          </TaxRateListItemWrap>
        </>
      )}
      {props.taxRates.map((taxRate) => {
        return (
          <TaxRateListItemWrap key={taxRate.id}>
            <TaxRateListItem
              teamUid={props.viewer.team!.uid}
              taxRate={taxRate}
              onClickMenu={onClickMenu}
              isLoading={props.isLoading}
              role={props.viewer.role}
            />
            {renderMenu(taxRate, props.viewer.role)}
          </TaxRateListItemWrap>
        );
      })}
      {props.taxRates.length === 0 &&
        !props.isLoading &&
        t(`Empty for taxRate`)}
    </Container>
  );
}

const TaxRateListItemWrap = styled.div`
  margin: 0 auto ${spacing(20)};
  :last-of-type {
    margin-bottom: 0;
  }
`;
const Container = styled.div`
  width: 100%;
`;
